export default __webpack_public_path__ + "static/german-1-b3adb4489a6edc0b65f9add9febc1708.png";